import { CSElement } from './CSElement';
import { ICSElement, SerializationOptions, SerializedElement } from '../types/interfaces';
import { ElementNavigation } from './ElementNavigation';

export class ElementSerializer {
  /**
   * Экспорт структуры в JSON
   */
  public static toJSON(element: ICSElement, includeData: boolean = true): any {
    const result: any = {
      id: element.id,
      name: element.name,
      index: element.index
    };

    if (includeData && element.data.size > 0) {
      result.data = Object.fromEntries(element.data);
    }

    if (element.elementsCount() > 0) {
      result.elements = element.getAllElements().map(child => {
        if (child instanceof CSElement) {
          return this.toJSON(child, includeData);
        }
        return null;
      }).filter(Boolean);
    }

    return result;
  }

  /**
   * Улучшенная сериализация с опциями
   */
  public static serialize(element: ICSElement, options: SerializationOptions = {}): SerializedElement {
    const {
      includeChildren = true,
      includeData = true,
      includeOwners = false,
      includeMetadata = true,
      maxDepth = Infinity,
      excludeFields = []
    } = options;

    const result: SerializedElement = {
      id: element.id
    };

    if (!excludeFields.includes('name')) {
      result.name = element.name;
    }
    if (!excludeFields.includes('index')) {
      result.index = element.index;
    }

    if (includeData && !excludeFields.includes('data') && element.data.size > 0) {
      result.data = Object.fromEntries(element.data);
    }

    if (includeOwners && !excludeFields.includes('owners')) {
      result.owners = (element as CSElement).getAllOwners().map(o => o.id);
    }

    if (includeMetadata && !excludeFields.includes('metadata')) {
      result.metadata = {
        createdAt: Date.now(), // This should be stored on creation
        updatedAt: Date.now(),
        depth: ElementNavigation.getDepth(element),
        path: ElementNavigation.getPath(element).join('/')
      };
    }

    if (includeChildren && !excludeFields.includes('children') && maxDepth > 0) {
      const children: SerializedElement[] = [];
      for (const child of element.getAllElements()) {
        if (child instanceof CSElement) {
          children.push(this.serialize(child, {
            ...options,
            maxDepth: maxDepth - 1
          }));
        }
      }
      if (children.length > 0) {
        result.children = children;
      }
    }

    return result;
  }
} 